import {Component, ElementRef, Input} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'hc-checkin',
    templateUrl: 'hc-checkin.html',
    providers: []
})
export class HcCheckin {

    //@Input('hpage')   hpage: WebsiteSpotPage;
    @Input('blocked') blocked: any;
    @Input('index') index: number;
    @Input('first') first: boolean;

    @Input('hpage')
    set hpageSet(data: WebsiteSpotPage) {

        this.hpage = data;

        let feedback = this.hpage.rootdata.Hotspots[0].Branded.BrandedBody.Hspot.Feedback;
        this.feedback = (feedback == this.hpage.THotpageFeedback.hfCheckin);

        let checkins = (this.hpage.rootdata.Paybooks || []);
        this.checkins = (checkins.length && !checkins[0].CheckinFeedback);

    }

    checkins: boolean;
    feedback: boolean;
    hpage: WebsiteSpotPage;

    constructor(public element: ElementRef) {

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/hc-checkin/hc-checkin.ts